import React, { useState, useEffect } from "react";
import { Card, Col, Row } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import "./App.css"; // Import your CSS file to apply styles

const CompanyAnalysis = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleCardClick = (message) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("question", message);
    navigate(`/?${searchParams.toString()}`);
  };

  const renderSection = (title, items) => (
    <div
      style={{
        margin: isMobile ? "20% 5% 15%" : "5% 5% 5%",
      }}
    >
      <h2>{title}</h2>
      <Row gutter={16} style={{ display: "flex", alignItems: "stretch" }}>
        {items.map((item, index) => (
          <Col
            key={index}
            xs={24}
            sm={12}
            md={8}
            lg={8}
            xl={8}
            style={{ display: "flex" }}
          >
            <Card
              title={item.title}
              bordered={false}
              style={{
                flex: 1,
                backgroundColor: "whitesmoke",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "transform 0.3s, box-shadow 0.3s",
              }}
              className="card-hover-effect"
              onClick={() => handleCardClick(item.message)}
            >
              {item.description}
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );

  return (
    <div
      style={{
        paddingTop: isMobile ? "5%" : "5%", // Adjust top padding here
        paddingBottom: isMobile ? "5%" : "5%", // Adjust bottom padding here
      }}
    >
      {renderSection("Single Company Analysis", [
        {
          title: "Top 7 Reasons to Buy Tesla",
          message: "What are the top 7 reasons to buy Tesla?",
          description: "Revenue growth, profitability, and market trends.",
        },
        {
          title: "Amazon Detailed Financial Analysis",
          message: "Provide a detailed financial analysis of Amazon.",
          description: "Assess revenue, costs, and profitability metrics.",
        },
        {
          title: "Latest Nvidia GPU Launches",
          message: "What are the latest GPU launches by Nvidia?",
          description: "Explore new products and market impact.",
        },
      ])}

      {renderSection("Compare Companies", [
        {
          title: "Amazon vs Microsoft Cloud",
          message: "Compare Amazon vs Microsoft Cloud services.",
          description: "Cloud revenue, growth, and market share.",
        },
        {
          title: "Nvidia vs AMD Earnings Analysis",
          message: "Analyze Nvidia and AMD latest earnings calls.",
          description: "Earnings growth and market performance.",
        },
        {
          title: "Meta vs Snapchat User Base Analysis",
          message: "Compare Meta vs Snapchat user base performance.",
          description: "User engagement, revenue, and market trends.",
        },
      ])}

      {renderSection("Valuation by DCF", [
        {
          title: "Costco Valuation Analysis",
          message: "What is the fair value of Costco?",
          description: "Estimate future cash flows and intrinsic value.",
        },
        {
          title: "Walmart Valuation",
          message: "DCF Valuation of Walmart.",
          description: "Assess financials to determine intrinsic value.",
        },
        {
          title: "Snapchat Valuation",
          message: "DCF Valuation of Snapchat.",
          description: "Review forecasted cash flows and valuation metrics.",
        },
      ])}
    </div>
  );
};

export default CompanyAnalysis;
